import { render, staticRenderFns } from "./Movement.vue?vue&type=template&id=3c12ede8"
import script from "./Movement.vue?vue&type=script&lang=js"
export * from "./Movement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports